import { Introduction, About, Resume, Portfolio, Contact } from ".";

const DefaultRoutes = () => (
  <>
    <Introduction />
    <About />
    <Resume />
    <Portfolio />
    <Contact />
  </>
);

export { DefaultRoutes };
